/**
 * Query keys for the schedule view contacts table.
 *
 * The `data` segment carries the selected schedule, which the table reads
 * directly; it was already part of this table's key before the factory.
 */
export const scheduleViewContactKeys = {
  all: ["schedule-view-contacts"],
  lists: () => [...scheduleViewContactKeys.all, "list"],
  list: ({ campaignId = null, data = null } = {}) => [
    ...scheduleViewContactKeys.lists(),
    { campaignId },
    data,
  ],
};
